import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Board } from "./pages/Board";
import { LeadDetailPage } from "./pages/LeadDetail";
import { Analytics } from "./pages/Analytics";
import { TasksPage } from "./pages/Tasks";
import { Login } from "./pages/Login";
import { hasToken } from "./lib/api";

function Protected({ children }: { children: React.ReactNode }) {
  if (!hasToken()) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Board />} />
        <Route path="lead/:id" element={<LeadDetailPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="voice" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
